export const SCREEN_ASSET_ID = 'Oct2022'
export const WAITLIST_SCREEN_ASSET_ID = '2023_waitlist'

export type EventBase = {
  event_type: EventType
  device_id?: string
  user_id?: string
}

export type TrackingBase = {
  asset_id: string
  screen: string
  event_category?: EventCategory
}

export interface ButtonTracking extends TrackingBase {
  asset_text: string
}

export interface NavigationTracking extends TrackingBase {
  asset_text: string
}
export interface ScreenTracking extends TrackingBase {
  heading: string
  from_screen: string
}

export interface PromocodeTracking {
  code_used: string
}

export enum EventType {
  SCREEN_OPENED = 'web_app_screen_opened',
  BUTTON_PRESSED = 'web_app_button_pressed',
  NAVIGATION_PRESSED = 'web_app_navigation_pressed',
  VALIDATED_PROMOCODE = 'web_app_code_entered_successfully'
}

export enum EventCategory {
  BUTTON = 'button',
  NAVIGATION = 'navigation',
  SCREEN = 'screen'
}

export type TrackingEvents =
  | ButtonTracking
  | ScreenTracking
  | NavigationTracking
  | PromocodeTracking

export type TrackingEvent<TrackingEvents> = EventBase & {
  event_properties: TrackingEvents
}

export enum USER_PROPERTIES {
  EXTERNAL_ID = 'externalId'
}
